import React from 'react';
import _ from '../../i18n.jsx';
import style from './weight.height.less';
import FormPureComponent  from '../generic.component.jsx';
import SmallInput from '../small.input/small.input.jsx';
import DontKnowBtn from '../dont.know.btn/dont.know.btn.jsx';
import Slider from '../slider/slider.jsx';

const UNKNOWN = 'UNKNOWN';
export default class Height extends FormPureComponent {
    constructor() {
        super();
        this.state = { inches: 0, centimeters: 0, foots: 0 };
        this.onChangePreprocessor = this.onChangePreprocessor.bind(this);
        this.onSliderMove = this.onSliderMove.bind(this);
    }

    componentDidMount() {
        const height = this.props.value;
        if (height === UNKNOWN) { return; }
        this.setState({
            inches: Height.cmToInch(Height.mmToCm(height)) % Height.INCH_IN_FOOT,
            centimeters: Height.mmToCm(height),
            foots: Height.cmToFoot(Height.mmToCm(height))
        });
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.value !== this.props.value && nextProps.value === UNKNOWN) {
            this.setState({ foots: 0, inches: 0, centimeters: 0 });
        }
    }
    static inchToCm(inch) { return Math.round(inch / Height.CM_IN_INCH) || 0; }
    static ftToCm(ft)     { return Math.round(ft / Height.CM_IN_FOOT) || 0; }
    static cmToFoot(cm)   { return Math.floor(cm * Height.CM_IN_FOOT) || 0; }
    static cmToInch(cm)   { return Math.floor(cm * Height.CM_IN_INCH) || 0; }
    static mmToCm(mm)     { return mm / Height.MM_IN_CM || 0; }
    static cmToMm(cm)     { return cm * Height.MM_IN_CM || 0; }
    static validateHeight(value, min, max) {
        const intValue = parseInt(value);
        return max >= intValue && intValue >= min;
    }
    onSliderMove(value) {
        const disabled = this.props.disabled;
        if (disabled) { return; }
        this.setState({
            centimeters: value,
            inches: Height.cmToInch(value) % Height.INCH_IN_FOOT,
            foots: Height.cmToFoot(value)
        });
    }
    onChangePreprocessor(name, value) {
        let _value;
        const { foots, inches } = this.state;
        switch (name) {
            case 'centimeters':
                _value = parseInt(value) || 0;
                this.setState({
                    centimeters: _value,
                    inches: Height.cmToInch(value) % Height.INCH_IN_FOOT,
                    foots: Height.cmToFoot(value)
                });
                break;
            case 'inches':
                _value = Height.inchToCm(value) + Height.ftToCm(foots);
                this.setState({
                    centimeters: _value,
                    inches: parseInt(value) || 0
                });
                break;
            case 'foots':
                _value = Height.inchToCm(inches) + Height.ftToCm(value);
                this.setState({
                    centimeters: _value,
                    foots: parseInt(value) || 0
                });
                break;
            case 'slider':
            default:
                _value = value;
                this.setState({
                    centimeters: _value,
                    inches: Math.floor(Height.cmToInch(value)) % Height.INCH_IN_FOOT,
                    foots: Math.floor(Height.cmToInch(value) / Height.INCH_IN_FOOT)
                });
        }
        this.onChangeHandler(Height.cmToMm(_value));
    }
    render() {
        const { min, max, disabled } = this.props;
        const { foots, inches, centimeters } = this.state;
        const isCorrectFoots = 0 !== foots ? Height.validateHeight(foots, 0, 7) : true;
        const isCorrectInches = 0 !== inches ? Height.validateHeight(inches, 0, 11) : true;
        const isCorrectCentimeters = 0 !== centimeters ? Height.validateHeight(centimeters, min / 10, max / 10) : true;
        const STRINGS = Height.STRINGS;
        return (
            <div className={style.wrapper}>
                <div className={style.fieldWrapper}>
                    <SmallInput onlyNumbers={true} disabled={disabled} error={!isCorrectFoots} length="2" name="foots"
                        title={STRINGS.ENGLISH} value={foots} unit="ft" onChangeCallback={this.onChangePreprocessor}/>
                    <SmallInput onlyNumbers={true} disabled={disabled} error={!isCorrectInches} length="2" name="inches"
                        value={inches} unit="in" onChangeCallback={this.onChangePreprocessor}/>
                    <span className={style.or}>{STRINGS.OR}</span>
                    <SmallInput onlyNumbers={true} disabled={disabled} error={!isCorrectCentimeters} length="3" name="centimeters"
                        title={STRINGS.METRIC} value={centimeters} unit="cm" onChangeCallback={this.onChangePreprocessor}/>
                </div>
                <Slider disabled={disabled} error={!isCorrectCentimeters} min={Height.mmToCm(min)} max={Height.mmToCm(max)}
                    sliderMoveCallback={this.onSliderMove} name="slider" value={centimeters} onChangeCallback={this.onChangePreprocessor}/>
                <DontKnowBtn disabled={disabled} onChangeCallback={this.onChangeHandler}
                    wrapperClass={style.dontKnowButtonWrapper} value={UNKNOWN} checked={UNKNOWN === this.props.value}/>
            </div>
        );
    }
}
Height.CM_IN_INCH = 0.393701;
Height.CM_IN_FOOT = 0.03280841666667;
Height.MM_IN_CM = 10;
Height.INCH_IN_FOOT = 12;
Height.defaultProps = {
    value: 0
};
Height.STRINGS = {
    ENGLISH: _('English system'),
    METRIC: _('Metric system'),
    OR: _('or')
};
